"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var CountCacheInMemory = function () {
  function CountCacheInMemory() {
    (0, _classCallCheck3.default)(this, CountCacheInMemory);

    this.clear();
  }

  (0, _createClass3.default)(CountCacheInMemory, [{
    key: "clear",
    value: function clear() {
      this.counters = {};

      return this;
    }
  }, {
    key: "state",
    value: function state() {
      return this.counters;
    }
  }, {
    key: "track",
    value: function track(metricName) {
      if (this.counters[metricName] === undefined) this.counters[metricName] = 1;else this.counters[metricName]++;

      return this.counters[metricName];
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return (0, _keys2.default)(this.counters).length === 0;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.counters;
    }
  }]);
  return CountCacheInMemory;
}();

module.exports = CountCacheInMemory;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/storage/CountCache/InMemory.js
// module id = 717
// module chunks = 10